var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('Table',{attrs:{"servicePath":'company/list',"headers":_vm.companyHeaders,"title":_vm.title,"sortBy":_vm.sortBy,"sortDesc":_vm.sortDesc,"fieldClickable":_vm.fieldClickable,"icon":"mdi-briefcase-download","tableType":"company"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }